import PropTypes from "prop-types";

import TabContainer from "./TabContainer";
import TabContent from "./TabContent";
import TabPane from "./TabPane";

const propTypes = {
  ...TabPane.propTypes,

  disabled: PropTypes.bool,

  title: PropTypes.node,

  /**
   * tabClassName is used as className for the associated NavItem
   */
  tabClassName: PropTypes.string,
};

function Tab(props) {
  const {
    title, disabled, tabClassName, ...rest
  } = props;

  return <TabPane {...rest} />;
}

Tab.propTypes = propTypes;

Tab.Container = TabContainer;
Tab.Content = TabContent;
Tab.Pane = TabPane;

export default Tab;
